export default {
  dev: "http://127.0.0.1:8000/en/api/requests/",
  staging: "https://cm.staging.mircloud.de/en/api/requests/",
  live: "https://cm.live.mircloud.de/en/api/requests/"
}
